import { tipoSolicitudCambioCic } from "../../constantes/tipoSolicitudCambioCic";
import OperacionesCambioCodeudor from "./CambioCodeudor/OperacionesCambioCodeudor";
import OperacionesCambioDeudor from "./CambioDeudor/OperacionesCambioDeudor";
import OperacionesCambioCuentasPorCobrar from "./CuentasPorCobrar/OperacionesCambioCuentasPorCobrar";
import OperacionesCambioCuotasAtrasadas from "./CuotasAtrasadas/OperacionesCambioCuotasAtrasadas";
import OperacionesDelDeudor from "./EliminarOperacion/OperacionesDelDeudor";
import OperacionesIncluirOperacionNoReportada from "./IncluirOperacionNoReportada/OperacionesIncluirOperacionNoReportada";
import OperacionesModificarMotivoLiquidacion from "./MotivoLiquidacion/OperacionesModificarMotivoLiquidacion";

function OperacionesCambioCic({
  operaciones,
  tipoSolicitud,
  actualizarOperaciones,
}) {
  return (
    <>
      {tipoSolicitud ===
      tipoSolicitudCambioCic.TrasladarInformacionCrediticiaDeUnDeudorAOtro ? (
        <OperacionesCambioDeudor
          operaciones={operaciones}
          actualizarOperaciones={actualizarOperaciones}
          permiteSeleccionar="true"
        />
      ) : null}

      {tipoSolicitud ===
      tipoSolicitudCambioCic.ModificarOEliminarCuotasAtrasadas ? (
        <OperacionesCambioCuotasAtrasadas
          operaciones={operaciones}
          actualizarOperaciones={actualizarOperaciones}
          permiteSeleccionar="true"
        />
      ) : null}

      {tipoSolicitud ===
      tipoSolicitudCambioCic.ModificarOEliminarCuentasPorCobrarAsociadas ? (
        <OperacionesCambioCuentasPorCobrar
          operaciones={operaciones}
          actualizarOperaciones={actualizarOperaciones}
          permiteSeleccionar="true"
        />
      ) : null}

      {tipoSolicitud === tipoSolicitudCambioCic.IncluirMotivoDeLiquidacion ? (
        <OperacionesIncluirOperacionNoReportada
          operaciones={operaciones}
          actualizarOperaciones={actualizarOperaciones}
          permiteSeleccionar="true"
        />
      ) : null}

      {tipoSolicitud === tipoSolicitudCambioCic.ModificarMotivoDeLiquidacion ? (
        <OperacionesModificarMotivoLiquidacion
          operaciones={operaciones}
          actualizarOperaciones={actualizarOperaciones}
          permiteSeleccionar="true"
        />
      ) : null}

      {tipoSolicitud === tipoSolicitudCambioCic.ExcluirOSustituirCodeudor ? (
        <OperacionesCambioCodeudor
          operaciones={operaciones}
          actualizarOperaciones={actualizarOperaciones}
          permiteSeleccionar="true"
        />
      ) : null}

      {tipoSolicitud ===
      tipoSolicitudCambioCic.EliminarOperacion ? (
        <OperacionesDelDeudor
          operaciones={operaciones}
          actualizarOperaciones={actualizarOperaciones}
          permiteSeleccionar="true"
        />
      ) : null}
    </>
  );
}

export default OperacionesCambioCic;
